import React, { useCallback, useState, Fragment } from 'react';

import { ArrowDown, ArrowRight, ArrowUp } from '@travel/icons/ui';
import { Translate } from '@travel/translation';
import Invisible from '@travel/traveler-core/components/Invisible';
import { TitleAccordion } from '@travel/ui';
import { cx } from '@travel/utils';

import Link from 'core/universalRouter/Link';

import paths from 'constants/paths';
import { labelTypes } from 'constants/seo';

import styles from '../internalLinks.module.scss';

import type { Area } from 'Common-Types';
import type { InternalLink } from 'HotelList-Types';

export type Props = {
  data: Array<InternalLink>;
  heading: string;
};

const InternalLinksSpData = (props: Props) => {
  const { data, heading } = props;
  const [openedPlaces, setOpenedPlaces] = useState('');
  const handleClick = useCallback(
    (clickedPlaceId?: string): void => {
      setOpenedPlaces(`${clickedPlaceId}` === openedPlaces ? '' : `${clickedPlaceId}`);
    },
    [openedPlaces],
  );

  const content = (places) => {
    return places?.map((place: Area) => {
      return (
        <Link
          key={`${place.pathId}`}
          to={paths.providerList.pathResolver(place.pathId)}
          className={cx(styles.accordionContent, styles.linkContainer)}
        >
          <span>{place.name}</span>
          <ArrowRight className={styles.arrowRightIcon} size={16} />
        </Link>
      );
    });
  };

  return (
    <div data-testid="internalLinksCard-spContainer-div" className={styles.mobileContainer}>
      <div className={styles.bottomSpacing}>
        <Translate id="Domestic.JRDP.Internal_Link_Label.Title" data={{ subivision: heading }} />
      </div>
      {data.map((internalLink: InternalLink, index: number) => {
        const isSelectedPlaceCLicked = index.toString() === openedPlaces;
        return (
          <Fragment key={`${internalLink.type}-${index}`}>
            <TitleAccordion
              className={cx(styles.dashLine, styles.accordionTitle)}
              titleClassName={styles.containerWrapper}
              id={`${internalLink.type}-${index}`}
              key={`${internalLink.type}-${index}`}
              title={
                <Translate
                  id={`Domestic.JRDP.Internal_Link_Label.${labelTypes[internalLink.type]}`}
                  data={{ subdivision: heading }}
                />
              }
              openClassName={styles.openTopLevel}
              expandIcon={<ArrowDown size={16} />}
              collapseIcon={
                <ArrowUp
                  size={16}
                  data-testid={`${internalLink.type}-upArrow`}
                  color={'lincolnGreen'}
                />
              }
              isOpen={isSelectedPlaceCLicked}
              onClick={() => handleClick(`${index}`)}
              isControlledByParent
              data-testId="InternalLinksSpData-arrow-sp"
            >
              <div className={styles.background}>
                <div
                  className={styles.accordionContentContainer}
                  data-testid="InternalLinksSpData-wrapper-div"
                >
                  {content(internalLink.places)}
                </div>
              </div>
            </TitleAccordion>
            {!isSelectedPlaceCLicked && (
              <Invisible>
                <div>{content(internalLink.places)}</div>
              </Invisible>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default React.memo(InternalLinksSpData);
